import { render, staticRenderFns } from "./TileDataBEMoWBestel.vue?vue&type=template&id=1ff71814"
import script from "./TileDataBEMoWBestel.vue?vue&type=script&lang=js"
export * from "./TileDataBEMoWBestel.vue?vue&type=script&lang=js"
import style0 from "./TileDataBEMoWBestel.vue?vue&type=style&index=0&id=1ff71814&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports